// THE WRITER STAMP every hive row carries beside its lane payload. Deliberately not a
// field of any lane schema — see the docblock below.
// Split out of `../hive-event.ts`, which is now the barrel over this directory.

import { z } from 'zod';

/**
 * The WRITER STAMP every hive row carries beside its lane payload: the version of the
 * runner binary that wrote it.
 *
 * NOT a field of any lane schema, on purpose. Rule 3 in `../hive-event.ts`'s header keeps every lane field
 * required, and a mixed fleet (pull-before-work, 45-minute maturity) writes both the
 * stamped and the pre-stamp shape for a window — so the stamp lives in its own schema,
 * REQUIRED at the one write seam that adds it (`apps/runner/src/hive-event.ts`
 * `hivePayload`, which every lane's round goes through) and read from the ROW
 * (`payload->>'runner_version'`), never through a lane schema, whose strip-mode parse
 * ignores it. That is what lets a reader say `writer=<version>` for a stamped row and
 * `no_provenance` for one written before the stamp, without any lane field going
 * `.optional()`. Measured 2026-09-03: 0 of 2,774 hive rows in 30 days shared a run with
 * a `run_provenance` row, because only the native coding adapter emitted one.
 */
export const HiveWriterStampSchema = z.object({
  /** The writing binary's version, the string the box also reports as `runners.runner_version`. */
  runner_version: z.string().min(1).describe('the runner binary that wrote this row'),
});
export type HiveWriterStamp = z.infer<typeof HiveWriterStampSchema>;
